"use client"

import { useEffect, useState } from "react"
import { useSession } from "next-auth/react"
import SignupForm from "./Signup/SignupForm"

const GatedForm = ({ abVariant}: { abVariant: boolean }) => {
   const [mounted, setMounted] = useState(false)
   const { data: session } = useSession()
   const isAuthenticated = !!session?.user

   const [showModal, setShowModal] = useState(false)

   useEffect(() => {
      setMounted(true)
   }, [])

   useEffect(() => {
      let timer: NodeJS.Timeout
      if (!isAuthenticated && abVariant && mounted) {
         timer = setTimeout(() => setShowModal(true), 1000)
      } else {
         setShowModal(false)
      }
      return () => clearTimeout(timer)
   }, [isAuthenticated, abVariant, mounted])

  

   useEffect(() => {
      if (!mounted) return

      // Only lock scroll when user is unauthenticated, in abVariant, and modal is shown
      if (!isAuthenticated && abVariant && showModal) {
         // const originalStyle = window.getComputedStyle(document.body)
         // const originalOverflow = originalStyle.overflow
         // const originalPaddingRight = originalStyle.paddingRight

         // const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth

         document.body.style.overflow = "hidden"
         // Only add padding-right if there *is* a scrollbar (desktop); on mobile this is 0
         // if (scrollbarWidth > 0) {
         //    document.body.style.paddingRight = `${scrollbarWidth}px`
         // }

         document.documentElement.style.overflow = "hidden"

         return () => {
            try {
               if (document.body) {
                  // document.body.style.overflow = originalOverflow
                  // document.body.style.paddingRight = originalPaddingRight
               }
               if (document.documentElement) {
                  document.documentElement.style.overflow = ""
               }
            } catch (error) {
               console.warn("Could not restore document styles:", error)
            }
         }
      }
   }, [mounted, isAuthenticated, abVariant, showModal])

   useEffect(() => {
      if (mounted && !isAuthenticated && abVariant && showModal) {
         const isMobile = window.innerWidth <= 768
         window.scrollTo({ top: isMobile ? 100 : 150, behavior: "instant" })
      }
   }, [mounted, isAuthenticated, abVariant, showModal])

   if (!mounted) return null

   return !isAuthenticated && abVariant ? (
      <div>
         <div className="flex-col-rev fixed inset-0 bottom-0 z-[999] flex h-[110vh] max-h-full w-full items-end justify-center overflow-hidden bg-gradient-to-t from-black/50 ">
            <div className="w-full overflow-hidden">
               <div
                  className={`not-prose flex w-screen max-w-full flex-col items-center justify-center gap-4 border-t bg-white px-8 py-8 text-center transition-transform duration-300 lg:max-h-[80vh] lg:overflow-y-scroll ${
                     showModal ? "translate-y-0" : "translate-y-full"
                  }`}
                  style={{ willChange: "transform" }}
               >
                  <SignupForm   />
               </div>
            </div>
         </div>
      </div>
   ) : null
}

export default GatedForm
